var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"right":"","variant":"link","no-caret":""}},[_c('template',{slot:"button-content"},[_c('font-awesome-icon',{attrs:{"icon":"cog"}})],1),_c('b-dropdown-item-button',{on:{"click":function($event){return _vm.edit()}}},[_vm._v("Edit")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }